import uploadReq$ from './uploadReq';
import { concatMap, filter, finalize, map, mergeMap, share, take } from 'rxjs/operators';
import { from, Observable } from 'rxjs';
import UploadedPhoto from '@/model/UploadedPhoto';
import lifecycleSignal$ from './lifecycleSignal';

const pending = new Map<File, UploadedPhoto>();
export const findUpload = (file: File) => pending.get(file);

const singles$ = uploadReq$.pipe(
    concatMap(data => from(data.files).pipe(map(({ file, id }) => {
        const photo = new UploadedPhoto(data.sessionId, data.finalizationMode, file, data.watermark, id);
        pending.set(file, photo);
        return photo;
    }))),
    // Bound the whole pipeline, including decoded images and ready thumbnails.
    // ponytail: four admitted photos; tune with production memory/throughput measurements.
    mergeMap(photo => new Observable<{ photo: UploadedPhoto; sessionId: string }>(observer => {
        if (!photo.active) { observer.complete(); return; }
        const done = lifecycleSignal$.pipe(filter(event => event.photo === photo), take(1))
            .subscribe(() => observer.complete());
        observer.next({ photo, sessionId: photo.sessionId });
        return () => done.unsubscribe();
    }).pipe(finalize(() => {
        if (pending.get(photo.file) === photo) pending.delete(photo.file);
    })), 4),
    share(),
);

export default singles$;
